<template>
  <div>
    <Header modeType="1" />
    <div class="content-center">
    <div class="banner">
      <div class="content">
        <div class="banner-title">千橙超级店长智慧门店</div>
        <div class="line" />
        <div class="desc">
          零售门店一站式数智化升级方案，帮助零售行业从采、管、销多维度全链路解决门店经营问题
          <!-- <div class="desc-content">为企业提供业务员外勤管理、销售管理、订单管理、佣金管理、客户管理等销售辅助功能，全面提升销售业绩；基于企业微信，无缝对接企业商城、ERP、WMS、OMS等企业管理系统，构建全链路全闭环的数字化业务体系。</div> -->
        </div>
        <div class="btn-wrap">
          <!-- <div
              class="btn1"
              @click="openModal"
            >免费试用</div> -->
          <div class="btn" @click="openModal">立即咨询</div>
        </div>
      </div>
    </div>
    <div class="improve" style="height:646px;">
        <div class="sk-block-title1">
            <div class="title1">零售门店经营升级挑战</div>
            <div class="sub-title1">消费市场的习惯与供需变化，对零售门店的经营增长呈现巨大压力</div>
        </div>
        <div class="content1">

        </div>
    </div>
    <div class="store">
        <div class="store_title">聚焦门店经营场景，实现线上线下经营闭环，帮老板实现线下店+线上店+社群店一店三开</div>
        <div class="store_banner">
            <img v-if="tooItem=='1'" src="@/assets/images/QcShopkeeper/item1.png" alt="">
            <img v-if="tooItem=='2'" src="@/assets/images/QcShopkeeper/item2.png" alt="">
            <img v-if="tooItem=='3'" src="@/assets/images/QcShopkeeper/item3.png" alt="">
            <img v-if="tooItem=='4'" src="@/assets/images/QcShopkeeper/item4.png" alt="">
            <img v-if="tooItem=='5'" src="@/assets/images/QcShopkeeper/item5.png" alt="">
            <img v-if="tooItem=='6'" src="@/assets/images/QcShopkeeper/item6.png" alt="">
            <img v-if="tooItem=='7'" src="@/assets/images/QcShopkeeper/item7.png" alt="">
            <img v-if="tooItem=='8'" src="@/assets/images/QcShopkeeper/item8.png" alt="">
            <img v-if="tooItem=='9'" src="@/assets/images/QcShopkeeper/item9.png" alt="">

        </div>
        <div class="store_box">
            <div :class="tooItem=='1'?'box_item1':'box_item'" @click="checkBg('1')">
                <img src="@/assets/images/QcShopkeeper/box1.png" alt="">
                <span>线上店</span>
            </div>
            <div :class="tooItem=='2'?'box_item1':'box_item'" @click="checkBg('2')">
                <img src="@/assets/images/QcShopkeeper/box2.png" alt="">
                <span>社群店</span>
            </div>
            <div :class="tooItem=='3'?'box_item1':'box_item'" @click="checkBg('3')">
                <img src="@/assets/images/QcShopkeeper/box3.png" alt="">
                <span>称重收银</span>
            </div>
            <div :class="tooItem=='4'?'box_item1':'box_item'" @click="checkBg('4')">
                <img src="@/assets/images/QcShopkeeper/box4.png" alt="">
                <span>进销存管理</span>
            </div>
            <div :class="tooItem=='5'?'box_item1':'box_item'" @click="checkBg('5')">
                <img src="@/assets/images/QcShopkeeper/box5.png" alt="">
                <span>经营分析</span>
            </div>
            <div :class="tooItem=='6'?'box_item1':'box_item'" @click="checkBg('6')">
                <img src="@/assets/images/QcShopkeeper/box6.png" alt="">
                <span>自助终端</span>
            </div>
            <div :class="tooItem=='7'?'box_item1':'box_item'" @click="checkBg('7')">
                <img src="@/assets/images/QcShopkeeper/box7.png" alt="">
                <span>便捷开单</span>
            </div>
            <div :class="tooItem=='8'?'box_item1':'box_item'" @click="checkBg('8')">
                <img src="@/assets/images/QcShopkeeper/box8.png" alt="">
                <span>智能巡店</span>
            </div>
            <div :class="tooItem=='9'?'box_item1':'box_item'" @click="checkBg('9')">
                <img src="@/assets/images/QcShopkeeper/box9.png" alt="">
                <span>智能货柜</span>
            </div>
        </div>
    </div>
    <div class="improve">
        <div class="sk-block-title1">
            <div class="title1">全流程升级优化，助力门店经营提效</div>
            <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
        </div>
        <div class="content">

        </div>
    </div>
    <div class="improve1">
        <div class="sk-block-title1">
            <div class="title1">支持层级区域管理，满足分公司、区域、加盟商多场景管理需求</div>
            <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
        </div>
        <div class="content">

        </div>
        <div class="shopkeeper_btn">
            <div class="btn" @click="linkTo('QcChain')">更多详见千橙连锁产品</div>
        </div>
    </div>
    <div class="improve" style="height:610px;">
        <div class="sk-block-title1">
            <div class="title1">专为智慧门店打造专属产品矩阵</div>
            <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
        </div>
        <div class="content2">
            <div class="content_box">
                <div class="box_item" @click="linkTo('QcErpSystem')"></div>
                <div class="box_item" @click="linkTo('QcShoppingMall')"></div>
                <div class="box_item" @click="linkTo('QcCashier')"></div>
                <div class="box_item" @click="linkTo('QcChain')"></div>
            </div>
        </div>
    </div>
    <div class="custom">
      <div class="sk-block-title1">
        <div class="title1">客户案例</div>
      </div>
      <div class="content">
        <el-carousel :autoplay="false" :interval="5000" arrow="never">
            <el-carousel-item >
            <div class="custom_item">
              <img src="@/assets/images/QcShopkeeper/custom_bg1.png" alt="">
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <Contact :infoSources="'汇通数科官网-千橙超级店长智慧门店'" />
    <TryModal
      v-if="visible"
      :visible="visible"
      info-sources="社群分销"
      @cancel="modalClose"
    />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import metaInfo from "@/common/util/metaInfo";
import TryModal from "@/components/TryModal";
import Contact from "@/components/Contact";

export default {
  metaInfo: metaInfo.QcShopkeeper,
  components: {
    Header,
    Footer,
    TryModal,
    Contact,
  },
  data() {
    return {
      visible: false,
      toolBg: require("@/assets/images/QcCashier/tool1.png"),
      tooItem: "1",
    };
  },
  mounted() {},
  methods: {
    linkTo(path) {
        if (!path.startsWith('/')) {
            path = '/' + path
        }
        this.$router.push({path})
    },
    checkBg(item) {
      this.tooItem = item;
      this.toolBg = "@/assets/images/QcCashier/tool" + item + ".png";
    },
    openModal: function () {
      this.visible = true;
    },
    modalClose: function (data) {
      this.visible = data;
    },
  },
};
</script>

<style lang="less" scoped>
.improve1{
    height: 919px;
    background: #F8FBFF;
    display: flex;
    flex-direction: column;
    // justify-content: center;
    align-items:center;
    position: relative;
    .content{
        margin-top:40px;
        width: 1200px;
        height:736px;
        background: url("~@/assets/images/QcShopkeeper/improve2.png") no-repeat;
        background-size: 1501px 736px;
    }
    .shopkeeper_btn{
        height: 46px;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items:center;
        position: absolute;
        bottom: 34px;
        left: 11px;
        .btn{
            width: 220px;
            height: 46px;
            background: #FFFFFF;
            border-radius: 30px;
            border: 1px solid #396FEB;
            font-size: 14px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #396FEB;
            line-height: 46px;
            text-align: center;
            cursor: pointer;
        }
    }
}
.improve{
    display: flex;
    flex-direction: column;
    // justify-content: center;
    align-items:center;
    .content{
        margin-top:40px;
        width: 1200px;
        height:581px;
        background: url("~@/assets/images/QcShopkeeper/improve.png") no-repeat center;
        background-size: 1200px 581px;
    }
    .content1{
        margin-top:50px;
        width: 1200px;
        height:398px;
        background: url("~@/assets/images/QcShopkeeper/improve1.png") no-repeat center;
        background-size: 1200px 398px;
    }
    .content2{
        margin-top:40px;
        width: 1200px;
        height:400px;
        background: url("~@/assets/images/QcShopkeeper/improve3.png") no-repeat center;
        background-size: 1200px 400px;
        position: relative;
        .content_box{
            width: 100%;
            height:50px;
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            position: absolute;
            bottom: 26px;
            .box_item{
                height:50px;
                width: 170px;
                cursor: pointer;
            }
        }
    }
}
.store{
        height:904px;
        background: #202239;
        display: flex;
        flex-direction: column;
        // justify-content: center;
        align-items:center;
        .store_banner{
            width: 1200px;
            height:478px;
            img{
                width: 1200px;
                height:478px;
            }
        }
        .store_title{
            width: 1030px;
            height: 117px;
            font-size: 36px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 50px;
            margin-top:69px;
        }
        .store_box{
            width: 1200px;
            height: 160px;
            margin-top:5px;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: start;
            .box_item{
                width: 200px;
                height: 68px;
                background: linear-gradient(97deg, #1F223B 0%, #354361 100%);
                border-radius: 6px;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                margin-left: 40px;
                margin-bottom: 20px;
                cursor: pointer;
                span{
                    height: 22px;
                    font-size: 16px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    color: #FFFFFF;
                    line-height: 22px;
                    margin-left: 10px;
                }
                img{
                    width: 30px;
                    height: 30px;
                }
            }
            .box_item1{
                width: 200px;
                height: 68px;
                background: linear-gradient(270deg, #6CB1FF 0%, #376CEA 100%);
                border-radius: 6px;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                margin-left: 40px;
                margin-bottom: 20px;
                cursor: pointer;
                span{
                    height: 22px;
                    font-size: 16px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    color: #FFFFFF;
                    line-height: 22px;
                    margin-left: 10px;
                }
                img{
                    width: 30px;
                    height: 30px;
                }
            }
        }
}
/deep/ i.el-icon-arrow-left {
    font-size: 35px;
    font-weight: 600;
}
/deep/ i.el-icon-arrow-right{
    font-size: 35px;
    font-weight: 600;
}
/deep/ button.el-carousel__arrow.el-carousel__arrow--left,button.el-carousel__arrow.el-carousel__arrow--right {
    width: 50px;
    height: 86px;
    border-radius: 0px;
    background-color: rgba(0,0,0,.4);
}
/deep/ button.el-carousel__arrow.el-carousel__arrow--right {
    width: 50px;
    height: 86px;
    border-radius: 0px;
    background-color: rgba(0,0,0,.4);
}

.custom{
    height:662px;
        background: url("~@/assets/images/qcerpsystem/carousel_bg.png") no-repeat center;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items:center;
    .content{
        width: 1200px;
        height:439px;
        margin: 0 auto;
        // padding: 53px 0;
        text-align: left;
        background: rgba(255,255,255,.5);
        // background: #FFFFFF;
        // opacity: 0.55;
        // border-radius: 8px;
        margin-top: 42px;
        /deep/ .el-carousel__container {
            position: relative;
            height: 439px;
        }
        .custom_item{
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            // padding:0 150px;
            img{
                width: 1200px;
                height: 439px;
            }
        }
    }
}
.case{
    background: #F8FBFF;
    .content{
        width: 1200px;
        margin: 0 auto;
        padding: 53px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
            width: 1171px;
            height:397px;
        }
    }
}

  .banner {
    background: url("~@/assets/images/QcShopkeeper/QcShopkeeper_banner.png") no-repeat center;
    background-size: 100% 100%;
    min-width: 1200px;
    min-height:420px;
    .content {
      width: 1200px;
      margin: 0 auto;
      padding: 53px 0;
      text-align: left;
      .banner-title {
        font-size: 48px;
        color: #FFFFFF;
        line-height: 55px;
      }
      .line {
        width: 100px;
        height: 6px;
        background: #28DAFB;
        margin: 16px 0 31px;
      }
      .desc {
        width: 600px;
        height: 101px;
        font-size: 20px;
        color: #FFFFFF;
        font-weight: normal;
        line-height: 28px;
        .desc-content{
            width: 600px;
            height: 96px;
            font-size: 16px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 32px;
        }
      }
      .btn-wrap {
        display: flex;
        .btn {
          width: 200px;
          height: 58px;
          line-height: 58px;
          border-radius: 6px;
          border: 1px solid #FFFFFF;
          font-size: 22px;
          color: #FFFFFF;
          cursor: pointer;
          text-align: center;
          margin-top: 47px;
          // margin-left:20px;
        }
        .btn1 {
          width: 200px;
          height: 58px;
          line-height: 58px;
          background: #3986FF;
          border-radius: 6px;
          font-size: 22px;
          color: #FFFFFF;
          cursor: pointer;
          text-align: center;
          margin-top: 47px;
        //   margin-left:20px;
        }
      }

  }

}
</style>
